import { Group, Progress, Stack, Text } from "@mantine/core"
import countBy from "lodash/countBy"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

export function MultiAnswerSingle(props: IMultiAnswerProps) {
  return (
    <MultiAnswerChoices
      choices={props.question.meta.choices.map((choice: string, idx: number) => ({
        value: idx,
        label: choice,
      }))}
      {...props}
    />
  )
}

interface IMultiAnswersChoicesProps extends IMultiAnswerProps {
  choices: { value: number; label: string }[]
  getSelected?: (value: any) => number[]
}

export function MultiAnswerChoices({ answers, choices, getSelected = (value) => [value] }: IMultiAnswersChoicesProps) {
  const doneAnswers = filterAnswersWithValue(answers)
  const selected = doneAnswers.flatMap((a) => getSelected(a.value))
  const values = countBy(selected)

  return (
    <Stack gap="xs">
      {choices.map((choice) => (
        <div key={choice.label}>
          <Group justify="space-between" gap={4} px={4}>
            <Text>{choice.label}</Text>
            <Text>{values[choice.value] || 0}</Text>
          </Group>
          <Progress size={18} color="blue.4" value={((values[choice.value] || 0) / doneAnswers.length) * 100} />
        </div>
      ))}
    </Stack>
  )
}
